import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import {ImportProvidersSource, Injectable} from '@angular/core';
import { Router } from '@angular/router';
import { AUTH_ACCESS_TOKEN_KEY, StorageService } from '../services/storage.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../services/auth.service';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private storageService: StorageService,
    private cookieService: CookieService,
    private authService: AuthService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(err => {
        if ([HttpStatusCode.Unauthorized, HttpStatusCode.Forbidden].includes(err.status) && this.storageService.getUser()) {
          return  this.handle401Error(req, next)
        }

        const error = err.error?.message || err.statusText;
        return throwError(() => error);
      }),
    )
  }

  private handle401Error(req: HttpRequest<any>, next: HttpHandler) {
    return this.authService.refreshToken().pipe(
      switchMap(authenticationResp => {
        return next.handle(this.requestWithTokenHeader(req));
      }),
      catchError(err => {
        this.authService.logOut();
        this.router.navigate(['/login'])
        const error = err.error?.message || err.statusText;
        return throwError(() => error);
      })
    );
  }

  private requestWithTokenHeader(req: HttpRequest<any>): HttpRequest<any> {
    req = req.clone({
      setHeaders: {
        "access_token": `${JSON.parse(this.cookieService.get(AUTH_ACCESS_TOKEN_KEY)).token}`
      }
    })
    return req
  }
}

export const httpAuthInterceptorProvider = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];
